import { PaymentResultStatusType } from "@/features/payment/wallet/domain/payment.type";
import { PaymentResultStatusMeta } from "@/features/payment/wallet/domain/payment.interface";
//@ts-ignore
import check from "@assets/images/dashboard/Wavy_Check.svg";
//@ts-ignore
import uncheck from "@assets/images/dashboard/Uncheck.svg";

export const paymentStatusMetaMap: Record<
  PaymentResultStatusType,
  PaymentResultStatusMeta
> = {
  PAYMENT_SUCCESS: {
    label: "پرداخت با موفقیت انجام شد",
    description: "جزئیات پرداخت",
    buttonText: "پیگیری وضعیت",
    bgColor: "#008B4580",
    backImg: check,
  },
  WALLET_CHARGE_SUCCESS: {
    label: "افزایش موجودی با موفقیت انجام شد",
    description: "جزئیات پرداخت",
    buttonText: "پیگیری وضعیت",
    bgColor: "#008B4580",
    backImg: check,
  },
  WALLET_CHARGE_FAILED: {
    label: "افزایش موجودی ناموفق بود",
    description:
      "چنانچه مبلغی از حساب شما کسر شده است، تا ۷۲ ساعت آینده به حساب شما باز خواهد گشت.",
    buttonText: "پیگیری وضعیت",
    bgColor: "#CF000080",
    backImg: uncheck,
  },
};
